import ActivitiesApi from '../api/activities';

const defaultFilters = {
  page: 1,
  limit: 10,
  sort: '-createdAt',
};

export default {
  namespaced: true,
  state: {
    activitiesCount: 0,
    activities: [],
    selectedActivity: null,
    isSelectedActivityCompleted: null,
    filters: defaultFilters,
  },
  getters: {
    activitiesCount(state) {
      return state.activitiesCount;
    },
    allActivities(state) {
      return state.activities;
    },
    filters(state) {
      return state.filters;
    },
    selectedActivity(state) {
      return state.selectedActivity;
    },
  },
  actions: {
    getActivities(context, params) {
      context.commit('SET_ACTIVITIES', { activities: [] });
      context.commit('SET_ACTIVITIES_COUNT', 0);

      if (params) {
        context.commit('SET_FILTERS', params);
      }

      return new Promise((resolve, reject) => {
        const filters = context.state.filters;
        const data = {
          ...filters,
          offset: filters.page * filters.limit - filters.limit,
          limit: filters.limit,
        };

        ActivitiesApi.getActivities(data)
          .then((response) => {
            context.commit('SET_ACTIVITIES', {
              activities: response.result,
            });

            context.commit('SET_ACTIVITIES_COUNT', response.count);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getActivitiesSharedByCouch(context, params) {
      context.commit('SET_ACTIVITIES', { activities: [] });
      context.commit('SET_ACTIVITIES_COUNT', 0);

      const selectedProgram = context.rootGetters['programs/selectedProgram'];
      if (!selectedProgram) {
        return Promise.resolve([]);
      }

      return new Promise((resolve, reject) => {
        ActivitiesApi.getActivitiesSharedByCouch(selectedProgram.slug, params)
          .then((response) => {
            context.commit('SET_ACTIVITIES', { activities: response.result });
            context.commit('SET_ACTIVITIES_COUNT', response.count);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getActivity(context, sessionId) {
      return new Promise((resolve, reject) => {
        ActivitiesApi.getActivity(sessionId)
          .then((response) => {
            context.commit('SET_SELECTED_ACTIVITY', response);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createActivity(context, activity) {
      return new Promise((resolve, reject) => {
        ActivitiesApi.createActivity(activity)
          .then((response) => {
            context.commit('SET_SELECTED_ACTIVITY', response);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateActivity(context, activity) {
      return new Promise((resolve, reject) => {
        ActivitiesApi.updateActivity(activity)
          .then((response) => {
            context.commit('SET_SELECTED_ACTIVITY', response);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteActivity(context, activityId) {
      return new Promise((resolve, reject) => {
        ActivitiesApi.deleteActivity(activityId)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getProgramActivities(context, programSlug) {
      return new Promise((resolve, reject) => {
        ActivitiesApi.getProgramActivities(programSlug)
          .then((response) => {
            context.commit('SET_ACTIVITIES', {
              activities: response,
            });

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    setSelectedActivity(context, activity) {
      context.commit('SET_SELECTED_ACTIVITY', activity);
    },
  },
  mutations: {
    SET_ACTIVITIES: (state, { activities }) => {
      state.activities = activities;
    },
    SET_FILTERS: (state, filters) => {
      state.filters = {
        language: filters.language || 'All',
        page: filters.page || defaultFilters.page,
        limit: filters.limit || defaultFilters.limit,
        sort: filters.sort || defaultFilters.sort,
        users: filters.users || [],
        programs: filters.programs || [],
        tags: filters.tags || [],
        level: filters.level || 'All',
        audience: filters.audience || 'All',
        search: filters.search || '',
      };
    },
    SET_ACTIVITIES_COUNT: (state, count) => {
      state.activitiesCount = count;
    },
    SET_SELECTED_ACTIVITY: (state, activity) => {
      state.selectedActivity = activity;
    },
  },
};
